import { DartsEvent } from "../types";

export const parseDisplayEventDate = (date: string): number => {
  const [year, month, dayAndTime] = date.split(" / ");
  if (!year || !month || !dayAndTime) {
    return Number.NaN;
  }

  const [day, time = "00:00"] = dayAndTime.split(" ");
  const isoLike = `${year}-${month}-${day}T${time}`;
  return new Date(isoLike).getTime();
};

export const compareEventDateAsc = (
  left: DartsEvent,
  right: DartsEvent,
): number => {
  const leftTime = parseDisplayEventDate(left.date);
  const rightTime = parseDisplayEventDate(right.date);

  if (Number.isNaN(leftTime) && Number.isNaN(rightTime)) {
    return 0;
  }
  if (Number.isNaN(leftTime)) {
    return 1;
  }
  if (Number.isNaN(rightTime)) {
    return -1;
  }

  return leftTime - rightTime;
};

export const isPastEvent = (
  event: DartsEvent,
  now: number = Date.now(),
): boolean => {
  if (event.status === "finished") {
    return true;
  }

  const eventTime = parseDisplayEventDate(event.date);
  return !Number.isNaN(eventTime) && eventTime < now;
};

export const splitEventsByTimeline = (
  events: DartsEvent[],
  now: number = Date.now(),
) => {
  const sortedEvents = [...events].sort(compareEventDateAsc);
  const upcomingEvents = sortedEvents.filter((event) => !isPastEvent(event, now));
  const pastEvents = sortedEvents
    .filter((event) => isPastEvent(event, now))
    .reverse();

  return {
    upNext: upcomingEvents[0] ?? null,
    schedule: upcomingEvents.slice(1),
    pastEvents,
  };
};

export const getJstYearLabel = (isoDateString: string): string => {
  if (!isoDateString) {
    return "不明";
  }

  const parsed = new Date(isoDateString);
  if (Number.isNaN(parsed.getTime())) {
    return "不明";
  }

  const jst = new Date(parsed.getTime() + 9 * 60 * 60 * 1000);
  return String(jst.getUTCFullYear());
};
